<template>
  <v-card>
    <v-card-title class="i-dialog-header-div">
      <span class="g-heading-m g-bold">Select Publish Date</span>
    </v-card-title>

    <v-card-text class="text-center py-6">
      <span> Publish Date can be updated if required </span>

      <v-row justify="space-around" align="center">
        <v-date-picker
          class="mt-4 mt-md-6"
          elevation="0"
          :allowed-dates="allowedDates"
          :show-current="false"
          v-model="selectedPublishDate"
        ></v-date-picker>
      </v-row>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions class="i-dialog-actions-div justify-center">
      <v-btn rounded text class="i-btn-text-black" @click="handleCancel">
        <strong>Cancel</strong>
      </v-btn>

      <v-btn
        rounded
        class="i-btn-block-secondary"
        :disabled="!selectedPublishDate"
        :loading="publishing"
        @click="handleConfirm"
      >
        <strong>Confirm</strong>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import moment from 'moment-timezone'
import { minAllowedPromotionStartDate } from '@/modules/dataMaintenance/helper/PromotionPublishSchedule'

export default {
  props: {
    publishing: {
      type: Boolean,
      default: false
    },
    tenantCountryRegion: String
  },

  computed: {
    minAllowedPublishDate() {
      return minAllowedPromotionStartDate(this.tenantCountryRegion)
    }
  },

  data: () => ({
    selectedPublishDate: ''
  }),

  methods: {
    allowedDates(date) {
      return moment(date).isSameOrAfter(this.minAllowedPublishDate, 'day')
    },

    handleCancel() {
      this.selectedPublishDate = ''
      this.$emit('cancel')
    },

    handleConfirm() {
      this.$emit('confirm', this.selectedPublishDate)
    }
  }
}
</script>
